import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
export const BackgroundBeams = memo(({
  className
}: {
  className?: string;
}) => {
  const paths = ['M-380 -189C-380 -189 -312 216 152 343C616 470 684 875 684 875', 'M-373 -197C-373 -197 -305 208 159 335C623 462 691 867 691 867'
  // ... keeping first few paths for brevity, full array would be included in production
  ];
  return <div className={cn('absolute h-full w-full inset-0 [mask-size:40px] [mask-repeat:no-repeat] flex items-center justify-center bg-gray-900', className)} data-id="element-175">
      <svg className="z-0 h-full w-full pointer-events-none absolute" width="100%" height="100%" viewBox="0 0 696 316" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-176">
        <path d="M-380 -189C-380 -189 -312 216 152 343C616 470 684 875 684 875" stroke="url(#paint0_radial_242_278)" strokeOpacity="0.05" strokeWidth="0.5" data-id="element-177"></path>
        {paths.map((path, index) => <motion.path key={`path-${index}`} d={path} stroke={`url(#linearGradient-${index})`} strokeOpacity="0.4" strokeWidth="0.5" data-id="element-178"></motion.path>)}
        <defs data-id="element-179">
          {paths.map((path, index) => <motion.linearGradient id={`linearGradient-${index}`} key={`gradient-${index}`} initial={{
          x1: '0%',
          x2: '0%',
          y1: '0%',
          y2: '0%'
        }} animate={{
          x1: ['0%', '100%'],
          x2: ['0%', '95%'],
          y1: ['0%', '100%'],
          y2: ['0%', `${93 + Math.random() * 8}%`]
        }} transition={{
          duration: Math.random() * 10 + 10,
          ease: 'easeInOut',
          repeat: Infinity,
          delay: Math.random() * 10
        }} data-id="element-180">
              <stop stopColor="#1a3a34" stopOpacity="0" data-id="element-181"></stop>
              <stop stopColor="#1a3a34" data-id="element-182"></stop>
              <stop offset="32.5%" stopColor="#2c6e63" data-id="element-183"></stop>
              <stop offset="100%" stopColor="#4ECDC4" stopOpacity="0" data-id="element-184"></stop>
            </motion.linearGradient>)}
          <radialGradient id="paint0_radial_242_278" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(352 34) rotate(90) scale(555 1560.62)" data-id="element-185">
            <stop offset="0.0666667" stopColor="#1a3a34" data-id="element-186"></stop>
            <stop offset="0.243243" stopColor="#1a3a34" data-id="element-187"></stop>
            <stop offset="0.43594" stopColor="white" stopOpacity="0" data-id="element-188"></stop>
          </radialGradient>
        </defs>
      </svg>
    </div>;
});
BackgroundBeams.displayName = 'BackgroundBeams';